"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toObjectChainRecipe = void 0;
const to_object_chain_reduce_recipe_1 = require("./to-object-chain-reduce-recipe");
function toObjectChainRecipe(ing) {
    const base = (0, to_object_chain_reduce_recipe_1.toObjectChainReduceRecipe)(ing);
    return function (...keys) {
        return base.call(this, () => [], (acc, x) => {
            acc.push(x);
            return acc;
        }, ...keys);
    };
}
exports.toObjectChainRecipe = toObjectChainRecipe;
